var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51733 6.20924L6.02489 1.70168L5.39644 1.07324L0.888889 5.58079V6.20924H1.51733ZM1.88578 7.09813H0V5.21235L5.08222 0.130127C5.16557 0.0468068 5.27859 0 5.39644 0C5.5143 0 5.62732 0.0468068 5.71067 0.130127L6.968 1.38746C7.05132 1.47081 7.09813 1.58383 7.09813 1.70168C7.09813 1.81953 7.05132 1.93256 6.968 2.01591L1.88578 7.09813ZM0 7.98702H8V8.8759H0V7.98702Z",
    fill: "#51CDA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditComment);
export default __webpack_public_path__ + "static/media/EditComment.9723a8d7dc7521691cf45ffb87a8cd0f.svg";
export { ForwardRef as ReactComponent };